import { render } from "./HomeNews.vue?vue&type=template&id=f76d1dc6&scoped=true&ts=true"
import script from "./HomeNews.vue?vue&type=script&lang=ts"
export * from "./HomeNews.vue?vue&type=script&lang=ts"

import "./HomeNews.vue?vue&type=style&index=0&id=f76d1dc6&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f76d1dc6"]])

export default __exports__